export default "__VITE_ASSET__B2BazPB4__"